import { useEffect } from 'react';

export default function PageMeta({ title, description }) {
  useEffect(() => {
    // Format: "Duus Rustfri" for frontpage, "[Titel] - Duus Rustfri" for subpages
    const finalTitle = title ? (title.includes('Duus Rustfri') ? title : `${title} - Duus Rustfri`) : 'Duus Rustfri';
    document.title = finalTitle;

    if (description) {
      let metaDesc = document.querySelector('meta[name="description"]');
      if (!metaDesc) {
        metaDesc = document.createElement('meta');
        metaDesc.name = 'description';
        document.head.appendChild(metaDesc);
      }
      metaDesc.content = description;
    }
  }, [title, description]);

  return null;
}
